// extracted by mini-css-extract-plugin
module.exports = {"root":"ShopNext_root__so5xE","rootInner":"ShopNext_rootInner__R_ZpC"};